import React from "react";

const FacebookLoginLink = ({ error, onSignupPage = false }) => (
    <div>
        <p
            className="or"
            style={error && !onSignupPage ? { marginTop: "0px" } : {}}
        >
            or
        </p>
        <a
            className="button facebook ui_facebook full-width"
            href={
                "/accounts/facebook/login/?next=" +
                window.location.pathname +
                window.location.search.replace("&", "%26")
            }
        >
            <span>{`${
                onSignupPage ? "Sign Up" : "Log In"
            } with Facebook`}</span>
        </a>
    </div>
);

export default FacebookLoginLink;
